import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const { token } = useAuth();
  return children; //Only use in Local Dev env
  //return token ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;